<template>
  <v-text-field
    v-bind="attributes"
    v-model="valor"
    ref="input"
    :type="number ? 'number' : 'tel'"
    :flat="isToBeFlat"
    :disabled="disabled"
    :readonly="readonly"
    :class="{ transparente: transparente && isToBeFlat, direita: direita }"
    @input="onInput"
    @focus="onFocus"
    @blur="onBlur"
    @keydown="onkeydown"

    @keyup="$emit('keyup', $event)"
    @change="$emit('change', $event)"
    @click:append="$emit('click:append')"
  >
    <template v-slot:append>
      <slot name="append"></slot>
    </template>
    <!-- <template v-slot:prepend>
      <v-btn small icon color="primary" @click="decrement">
        <v-icon small>mdi-minus</v-icon>
      </v-btn>
    </template>
    <template v-slot:append-outer>
      <v-btn small icon color="primary" @click="increment">
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </template> -->
  </v-text-field>
</template>

<script>

export default {
  props: {
    value: {},
    decimais: {
      type: [String, Number],
      default: 2,
    },
    transparente: Boolean,
    raiseOnFocus: Boolean,
    select: {
      type: Boolean,
      default: true,
    },
    flat: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    configOff: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      valor: "0",
      internalChange: false,
      isFocused: false,
    };
  },

  computed: {
    attributes() {
      if (this.configOff) {
        return { ...this.$attrs };
      }
      return { ...this.$v.TEXT_FIELDS, ...this.$attrs };
    },
    
    isToBeFlat() {
      if (this.flat && this.raiseOnFocus && this.isFocused) {
        return false;
      } else {
        return this.flat;
      }
    },

    direita() {
      return true;
      if (this.isFocused) {
        if (this.disabled || this.readonly) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
  },

  mounted() {
    this.valor = this.formataNumero(this.value, this.number ? 0 : this.decimais);
  },

  methods: {
    onInput(value) {
      this.internalChange = true;

      value = value.replace(/[^0-9,.]/g, "");

      if (value.includes(".") && !value.includes(",")) {
        value = value.replace(".", ",");
      }

      this.valor = value;

      this.$emit("input", this.valorUS(this.valor));
    },

    // increment() {
    //   this.valor += parseFloat(this.value);
    //   this.$emit("input", this.valorUS(this.valor));
    // },

    // decrement() {
    //   this.valor -= parseFloat(this.value);
    //   this.$emit("input", this.valorUS(this.valor));
    // },

    // onKeyUpEnter(event) {
    //   this.onBlur();
    //   setTimeout(() => {
    //     event.target.select();
    //   }, 0);
    // },

    onkeydown(event) {
      const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"];
      const isNumber = /[0-9]/.test(event.key);
      const isComma = event.key === ",";
      const isDot = event.key === ".";
      const isCtrlCommand = (event.ctrlKey || event.metaKey) && ["a", "c", "x", "v"].includes(event.key.toLowerCase());

      // if (isDot && !this.valor.includes(",")) {
      //   this.valor.replace('.', ',');
      //   event.preventDefault();
      // } else 
      if (!isDot && !isNumber && !isComma && !allowedKeys.includes(event.key) && !isCtrlCommand) {
        event.preventDefault();
      }

      // Impede que "," seja digitado mais de uma vez
      if ((isDot || isComma) && this.valor.includes(",")) {
        event.preventDefault();
      }
    },

    onKeyPress(event) {
      function onlynumber(evt) {
        let theEvent = evt;
        let key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        //let regex = /^[0-9.,]+$/;
        let regex = /^[0-9,.]+$/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
      }

      onlynumber(event);
      // console.log(event.target.value);
      
    },

    onBlur() {
      this.internalChange = false;
      this.isFocused = false;
      this.valor = this.formataNumero(this.value, this.number ? 0 : this.decimais);
      this.$emit("blur");
    },

    onFocus(e) {
      this.isFocused = true;
      if (this.select) {
        e.target.select();
      }

      this.$emit("focus");
    },

    focus() {
      this.$refs.input.focus();
    },

    valorUS(valor) {
      if (valor) {
        return parseFloat(valor.replace(/\./g, "").replace(",", "."));
      }
    },

    valorBR(valor) {
      if (valor) {
        return valor.toString().replace(/\./g, ",");
      }
    },

    trunc(valor, decimais) {
      decimais = !decimais ? 2 : decimais;
      valor = valor.replace(/\./g, "").replace(",", ".");
      valor =
        Math.trunc(parseFloat(valor) * Math.pow(10, decimais)) /
        Math.pow(10, decimais);
      return valor;
    },

    formataNumero(number, decimals, dec_point, thousands_sep) {
      decimals = typeof decimals !== "undefined" ? decimals : 2;
      dec_point = typeof dec_point !== "undefined" ? dec_point : ",";
      thousands_sep =
        typeof thousands_sep !== "undefined" ? thousands_sep : ".";

      number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return "" + (Math.round(n * k) / k).toFixed(prec);
        },
        toFixedFix2 = function (n, prec) {
          return (
            "" + (Math.trunc(n * 1000000000000) / 1000000000000).toFixed(prec)
          );
        };
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      s = (prec ? toFixedFix2(n, prec) : "" + Math.round(n)).split(".");
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
      }
      return s.join(dec);
    },
  },

  watch: {
    value(val, oldval) {
      if (!this.internalChange) {
        this.valor = this.formataNumero(val, this.number ? 0 : this.decimais);
      }
    },
  },
};
</script>

<style scoped>
.direita.v-input >>> input {
  text-align: right !important;
}

.transparente >>> .v-input__slot {
  background: none;
}
</style>
